<template>
  <div class="edit">
    <trumbowyg ref='editor' v-model="content" :config="editorConfig"></trumbowyg>
  </div>
</template>
<script> 
import 'src/jquery-vendor' //JQUERY lib
import VueTrumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/langs/zh_tw.min.js'
import '../trumbowyg_plugin/upload/trumbowyg.upload'
import config from '../config/api.js'
// import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.min.js'
// import 'trumbowyg/dist/plugins/resizimg/resize.with.canvas.min.js'

const btns = [
      ['viewHTML'],
      ['undo', 'redo'], // Only supported in Blink browsers
      ['formatting'],
      ['strong', 'em', 'del'],
      ['superscript', 'subscript'],
      ['link'],
      ['insertImage','upload'],
      ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
      ['unorderedList', 'orderedList'],
      ['horizontalRule'],
      ['removeformat'],
      ['fullscreen']
    ]

export default {
  name: "Editor",
  props:['value'],
  components: {
    trumbowyg: VueTrumbowyg
  },
  data() {
    return {
        content: this.value,
        editorConfig: {
          plugins: {
            upload: {
              serverPath: config.imageUpload.url + '/editor'
            }
          },
          imgDblClickHandler1: this.getDefaultImgDblClickHandler,
          lang: 'zh_tw',
          imageWidthModalEdit: true,
          btnsDef: {
            uploadImga: {
                fn: function(a){ console.log(a)},
                tag: 'tagName',
                title: 'Button tooltip',
                text: 'Displayed button name',
                isSupported: function () { return true; },
                key: 'K',
                param: '' ,
                forceCSS: false,
                class: '',
                hasIcon: true,
                ico: 'insertImage',
                init: function (trumbowyg) { console.log(trumbowyg)}
            },
            alert: {
                fn: this.aaa,
                ico: 'blockquote'
            }
          },
          btns: btns,
          autogrow: false
        }
    };
  },
  watch: {
    value: function(newValue){
      this.content = (newValue)? newValue: ''
    },
    content: function(){
      this.$emit('input', this.content)
    }
  },
  mounted() {
    //  console.log()
    // this.$refs.editor.getRangeText()
    // console.log(this)
  },
  methods: {
    aaa: function(){
      var t =  $(this.$refs.editor).$el.trumbowyg;
       
      console.log(t)
    },
    bbb: function(){
      this.value = 'set new value'
    },
    getDefaultImgDblClickHandler: function (e) {
            // var t = $.trumbowyg 
            var t = this.$refs.editor;
            console.log(t)

            return function () {
                var $img = $(this),
                    src = $img.attr('src'),
                    base64 = '(Base64)';

                if (src.indexOf('data:image') === 0) {
                    src = base64;
                }

                var options = {
                    url: {
                        label: 'URL',
                        value: src,
                        required: true
                    },
                    alt: {
                        label: t.lang.description,
                        value: $img.attr('alt')
                    }
                };

                if (t.o.imageWidthModalEdit) {
                    options.width = {
                        value: $img.attr('width') ? $img.attr('width') : ''
                    };
                }

                t.openModalInsert(t.lang.insertImage, options, function (v) {
                    if (v.url !== base64) {
                        $img.attr({
                            src: v.url
                        });
                    }
                    $img.attr({
                        alt: v.alt
                    });

                    if (t.o.imageWidthModalEdit) {
                        if (parseInt(v.width) > 0) {
                            $img.attr({
                                width: v.width
                            });
                        } else {
                            $img.removeAttr('width');
                        }
                    }

                    return true;
                });
                return false;
            };
        },
    uploadImg: function(){
      var insertAudioCallback = function (v) {
            // controls should always be show otherwise the audio will
            // be invisible defeating the point of a wysiwyg
            var html = '<audio controls';
            if (v.src) {
                html += ' src=\'' + v.src + '\'';
            }
            if (v.autoplay) {
                html += ' autoplay';
            }
            if (v.muted) {
                html += ' muted';
            }
            if (v.preload) {
                html += ' preload=\'' + v + '\'';
            }
            html += '></audio>';
            var node = $(html)[0];
            this.$el.range.deleteContents();
            this.$el.range.insertNode(node);
            return true;
        };

      this.$el.openModalInsert(this.$el.trumbowyg.lang.insertAudio, this.$el.insertAudioOptions, insertAudioCallback);
    },
    handleImageAdded: function() {
      alert('a')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.edit {
  text-align: left;
  overflow: hidden;
  min-height: 400px;
  width: 100%
}
</style>
